import { UiSchema } from '@rjsf/utils';
import { JSONSchema7 } from 'json-schema';

const MIN_PASSWORD_LENGTH = 8;

function getRegisterUserFormSchema(): JSONSchema7 {
  return {
    type: 'object',
    properties: {
      username: {
        title: 'Username',
        type: 'string',
        minLength: 1,
        maxLength: 100,
      },
      display_name: {
        title: 'Display Name',
        type: 'string',
        maxLength: 150,
        description: 'Defaults to the username when left empty.',
      },
      password: {
        title: 'Password',
        type: 'string',
        minLength: MIN_PASSWORD_LENGTH,
      },
      is_superuser: {
        title: 'Superuser',
        type: 'boolean',
        default: false,
        description: 'Superusers can manage users and register new accounts.',
      },
    },
    required: ['username', 'password'],
  };
}

function getRegisterUserUiSchema(): UiSchema {
  return {
    password: {
      'ui:widget': 'password',
      'ui:placeholder': `At least ${MIN_PASSWORD_LENGTH} characters`,
    },
  };
}

export { getRegisterUserFormSchema, getRegisterUserUiSchema, MIN_PASSWORD_LENGTH };
